module.exports = __webpack_public_path__ + "static/brass_dragon-1e28659992856febdbbc3498f9be675d.jpg";